<template>
  <div v-if="enabled" class="languageSelectorWrapper mt-4 mr-2">
    {{ $t('Language') }}:
    <v-select
      class="languageSelector"
      v-model="$i18n.locale"
      :items="[
        { text: $t('Hungarian'), value: 'hu' },
        { text: $t('English'), value: 'en' }
      ]"
    >
    </v-select>
  </div>
</template>

<style>
.languageSelectorWrapper {
  width: 200px;
  text-align: right;
}

.languageSelector {
  display: inline-flex;
  width: 100px;
  margin-left: 3px;
}
</style>

<script>
import config from '../helpers/configProvider';

export default {
  name: 'LanguageSelector',

  data() {
    return {
      enabled: config.getEnv(config.enum.VUE_APP_MULTILANGUAGE_ENABLED)
    };
  },

  watch: {
    '$i18n.locale'(newLocale) {
      this.$vuetify.lang.current = newLocale;
      this.$cookies.set('language', newLocale, Infinity);
    }
  }
};
</script>
